import React from 'react';

export default class RemoveAssignmentsEquipmentLabel extends React.Component {
    render() {
        const { assignment, isBroker } = this.props.equipment;

        return (
            <span className="assignment-side-text">
                {assignment?.description}
                &nbsp;
                <span style={{ fontWeight: 'bold' }}>
                    {!isBroker && `(${assignment?.equipmentType?.description})`}
                </span>
            </span>
        );
    }
}
